import {isLZWKAPP, isLHAPP, isLZWKAPPIpad, getJsonFromUrl, judgeAPPVersion, printObject, isAndroid, isIos} from './index'
import axios from 'axios'

// { id: '', product: '', type: '', productField: '' }
export function wxPay (opts) {
    // window.payResult = (data) => {
    //     alert(JSON.stringify(data))
    // }
    const params = getJsonFromUrl()
    // alert(JSON.stringify(opts))
    const extHeaders = {
    }
    if (params.__token) {
        extHeaders.Authorization = params.__token
    }
    axios.get('/api/pay/wxpay', {
        params: {
            trade_type: 'APP',
            [opts.productField]: opts.id,
            product: opts.product || 'pay_lecture',
            ts:~~(Date.now() / 1000),
            ...opts.payParams,
        },
        headers: {
            ...extHeaders
        }
    })
        .then(res => {
            if (res.data.code !== 0) {
                // 限时免费支付和全额优惠券支付
                if (res.data.code === -1 && opts.success) {
                    opts.success()
                    return
                }
                return alert(res.data.msg)
            }
            const data = res.data.params
            if (window.systemType === 'android') {
                WKApp.payByWechat(data.appid, data.noncestr, data.package, data.partnerid, data.prepayid, data.sign, data.timestamp, opts.type)
            }
            if (window.systemType === 'ios') {
                window.webkit.messageHandlers.WKApp.postMessage({
                    function: "payByWechat",
                    json: {
                        appid: data.appid || '',
                        noncestr: data.noncestr,
                        package: data.package,
                        partnerid: data.partnerid,
                        prepayid: data.prepayid,
                        sign: data.sign,
                        timestamp: data.timestamp,
                        type: opts.type,
                    }
                })
            }
        })
        .catch(err => alert(err))
}

// { title: 'title', desc: '', url: '', icon: '' }
export function shareUrl(opts) {
    if (isLZWKAPP()) {
        if (window.systemType === 'android') {
            WKApp.shareUrl(opts.title, opts.desc, opts.url, opts.icon)
        }
        if (window.systemType === 'ios') {
            window.webkit.messageHandlers.WKApp.postMessage({
                "function": "shareUrl",
                "json": {
                    "share_description": opts.desc,
                    "share_icon": opts.icon,
                    "share_title": opts.title,
                    "share_url": opts.url,
                }
            })
        }
    }
}

// {
//     title: '标题',
//     desc: '文本',
//     shareUrl: '点击进入的链接',
//     icon: 'icon',
//     musicUrl: '音乐资源地址',
// }
export function shareMusic(opts) {
    if (isLZWKAPP()) {
        if (window.systemType === 'android') {
            WKApp.shareMusic(opts.title, opts.desc, opts.shareUrl, opts.icon, opts.musicUrl)
        }
        if (window.systemType === 'ios') {
            window.webkit.messageHandlers.WKApp.postMessage({
                function: "shareMusic",
                json: {
                    share_description: opts.desc,
                    share_icon: opts.icon,
                    share_title: opts.title,
                    share_url: opts.shareUrl,
                    share_music: opts.musicUrl,
                }
            })
        }
    }
}

// 分享图片
// sharePic({ pic: 123.jpg })
export function sharePic(opts) {
    if(isLHAPP()) {
        if (window.systemType === 'android') {
            LHAPP.shareImage(opts.pic)
        }
        if (window.systemType === 'ios') {
            window.webkit.messageHandlers.LHAPP.postMessage({
                function: "shareImage",
                json: {
                    "share_image_url": opts.pic,
                }
            })
        }
    }else if (isLZWKAPP()) {
        if (window.systemType === 'android') {
            WKApp.shareImage(opts.pic)
        }
        if (window.systemType === 'ios') {
            window.webkit.messageHandlers.WKApp.postMessage({
                function: "shareImage",
                json: {
                    "share_image_url": opts.pic,
                }
            })
        }
    }
}

export function upload(ctx, e) {
    try{
        const file = e.target.files[0]
        if (!file) return
        const _this = ctx
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = function(e) {
            _this.setState({ cover: this.result, file })
        }
        _this.setState({ isPending: true })
        const formData = new FormData()
        formData.append('nickname', '李老师')
        formData.append('introduction', '233333')
        if (file) formData.append('headimgurl', file)
        axios.post('/api/account/edit', formData)
            .then(res => {
                _this.setState({ isPending: false })
                if (res.data.code === 0) {
                    alert('上传成功')
                } else {
                    alert(res.data.msg)
                }
            })
            .catch(err => alert(err))
    } catch(e) {
        alert('抱歉，你的设备暂不支持图片上传，请到讲师管理后台进行操作')
    }
}

// 通知APP课程或专栏修改成功
// updateSuccess({ type: 'lecture' })
export function updateSuccess (opts) {
    if (isLZWKAPP()) {
        if (window.systemType === 'android') {
            WKApp.updateSuccess(opts.type)
        }
        if (window.systemType === 'ios') {
            window.webkit.messageHandlers.WKApp.postMessage({
                function: "updateSuccess",
                type: opts.type,
            })
        }
    }
}

// 通知APP课程或专栏删除成功
// { type: 'lecture' }
export function delSuccess (opts) {
    if (isLZWKAPP()) {
        if (window.systemType === 'android') {
            WKApp.deleteSuccess(opts.type)
        }
        if (window.systemType === 'ios') {
            window.webkit.messageHandlers.WKApp.postMessage({
                function: "deleteSuccess",
                type: opts.type,
            })
        }
    }
    
}
// 返回原生的上一页
export function goBack () {
    if (window.systemType === 'android' && judgeAPPVersion(260)) {
        WKApp.goBackPrePage()
    }
    if (window.systemType === 'ios' && judgeAPPVersion(360)) {
        window.webkit.messageHandlers.WKApp.postMessage({
            function: "goBackPrePage"
        })
    }
}

// 去邀请卡页面
export function toShareCardPage(type, id) {
    if (window.systemType === 'android' && judgeAPPVersion(262)) {
        WKApp.toShareCardPage(type, +id)
    }
    if (window.systemType === 'ios' && judgeAPPVersion(370)) {
        window.webkit.messageHandlers.WKApp.postMessage({
            function: "toShareCardPage",
            type: type,
            id: +id,
        })
    }
}

// 创建成功（课程或专栏） 
export function addSuccess(type, id) {
    if (window.systemType === 'android' && judgeAPPVersion(260)) {
        WKApp.addSuccess(type, +id)
    }
    if (window.systemType === 'ios' && judgeAPPVersion(361)) {
        window.webkit.messageHandlers.WKApp.postMessage({
            function: "addSuccess",
            type: type,
            id: +id,
        })
    }
}

// 课程跳转
// toLecture({ id: 1 [, inviterid: 110, lectureMode: 'video', isReturn: false,] })
// isReturn 如果为true，该方法会返回地址，而不是跳转
export function toLecture(opts) {
    let obj = {}
    const inviterId = opts.inviterid || opts.inviterId
    if (inviterId) {
        obj = { ...obj, inviter_id: inviterId }
    }
    if (opts.id) {
        obj = { ...obj, lecture_id: opts.id }
    }
    const query = printObject(obj)
    const isSuitAndroid = isAndroid() && judgeAPPVersion(360)
    const isSuitIos = (isIos() && judgeAPPVersion(410)) || isLZWKAPPIpad()
    if (opts.lectureMode && (isSuitAndroid || isSuitIos)) {
        if (opts.lectureMode === 'audio' || opts.lectureMode === 'video') {
            if (opts.isReturn) {
                return `lizhiweike://record?${query}`
            }
            location.assign(`lizhiweike://record?${query}`)
            return 
        }
    }
    if (opts.isReturn) {
        return `lizhiweike://lecture?${query}`
    }
    location.assign(`lizhiweike://lecture?${query}`)
}

// 专栏跳转
export function toChannel(id, inviterid) {
    if (inviterid){
        location.assign(`lizhiweike://channel?channel_id=${id}&inviter_id=${inviterid}`)
    }else {
        location.assign(`lizhiweike://channel?channel_id=${id}`)
    }
}

// 课堂页跳转(直播课才有)
export function toClassroom(id, inviterid) {
    if (inviterid) {
        location.assign(`lizhiweike://classroom?lecture_id=${id}&inviter_id=${inviterid}`)
    } else {
        location.assign(`lizhiweike://classroom?lecture_id=${id}`)
    }
}

// 专栏跳转加强版（今后逐渐用这个）
// toChannel({ id: 1 [, inviterid: 110, isHasCoupon: true,] })
export function _toChannel(opts) {
    let obj = { channel_id: opts.id }
    const inviterId = opts.inviterid || opts.inviterId
    if (inviterId) {
        obj = { ...obj, inviter_id: inviterId }
    }
    if (opts.isHasCoupon) {
        obj = { ...obj, is_has_coupon: 'true' }
    }
    const query = printObject(obj)
    console.log(`lizhiweike://channel?${query}`)
    location.assign(`lizhiweike://channel?${query}`)
}

// 店铺跳转
export function toLiveroom(id) {
    location.assign(`lizhiweike://liveroom?liveroom_id=${id}`)
}


// WEBPACK FOOTER //
// ./src/utils/connectApp.js